import {useFeatureFlag} from '../../hooks/useFeatureFlag'
import {FACIAL_RECOGNITION_TABS, FacialRecognitionTab} from './constants'

export interface FacialRecognitionTabsState {
  visibleTabs: FacialRecognitionTab[]
  // True while any tab flag is still resolving.
  loading: boolean
}

/**
 * The registered tabs whose own flag is on, in registry order. The menu item,
 * the route wrapper and the page all read this, so they cannot disagree.
 */
export const useFacialRecognitionTabs = (): FacialRecognitionTabsState => {
  // The registry is a module constant, so the number and order of these hook
  // calls never changes between renders.
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const flags = FACIAL_RECOGNITION_TABS.map((tab) =>
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useFeatureFlag(tab.flagKey, false),
  )

  return {
    visibleTabs: FACIAL_RECOGNITION_TABS.filter((_, i) => flags[i].value),
    loading: flags.some((flag) => flag.loading),
  }
}
